import { productCreateActions } from "./actions/create.actions";
import { productUpdateActions } from "./actions/update.actions";
import { productCreateMutations } from "./mutations/create.mutations";
import { productsLoadingMutations } from "./mutations/loading.mutations";
import { productUpdateMutations } from "./mutations/update.mutations";
import { modules } from "./module";
export const productModule = {
  namespaced: true,
  state: () => ({
    productList: [],
    loading: false,
    product: {},
  }),
  getters: {},
  mutations: {
    ...productCreateMutations,
    ...productUpdateMutations,
    ...productsLoadingMutations,
  },
  actions: {
    ...productCreateActions,
    ...productUpdateActions,
  },
  modules,
};
